import type { Connector } from 'wagmi'

type EIP1193Provider = {
  request(args: { method: string; params?: unknown[] | object }): Promise<unknown>
}

function parseChainId(value: unknown): number | undefined {
  if (typeof value === 'number' && Number.isFinite(value)) return value
  if (typeof value === 'bigint') {
    const asNumber = Number(value)
    return Number.isFinite(asNumber) ? asNumber : undefined
  }
  if (typeof value === 'string' && value !== '') {
    const parsed = Number(value)
    return Number.isFinite(parsed) ? parsed : undefined
  }
  return undefined
}

async function chainIdFromProvider(connector: Connector): Promise<number | undefined> {
  if (typeof connector.getProvider !== 'function') return undefined

  let provider: EIP1193Provider
  try {
    provider = (await connector.getProvider()) as EIP1193Provider
  } catch {
    return undefined
  }

  if (!provider || typeof provider.request !== 'function') return undefined

  try {
    return parseChainId(await provider.request({ method: 'eth_chainId' }))
  } catch {
    return undefined
  }
}

/**
 * Cadena actual de la wallet. Algunos conectores RainbowKit/wagmi no exponen `getChainId`.
 */
export async function getConnectorChainId(connector: Connector | undefined): Promise<number | undefined> {
  if (!connector) return undefined

  if (typeof connector.getChainId === 'function') {
    try {
      return parseChainId(await connector.getChainId())
    } catch {
      /* fallback below */
    }
  }

  return chainIdFromProvider(connector)
}
